import { render, staticRenderFns } from "./FeedContent.vue?vue&type=template&id=2180d036&scoped=true&"
import script from "./FeedContent.vue?vue&type=script&lang=js&"
export * from "./FeedContent.vue?vue&type=script&lang=js&"
import style0 from "./FeedContent.scss?vue&type=style&index=0&id=2180d036&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2180d036",
  null
  
)

export default component.exports